// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton--sfhbE","loader":"loader--BOBmm","blink":"blink--mF79L"};